export default function() {
  return {
    projects: [],
    project: null,
    tempCategories: [],
    tempTags: [],
    createdProjectIdea: null,
    projectDashboardStats: null,
    applicationProcess: [],
    financialPlan: null,
    archivedProjects: [],
    prioritizedProjects: []
  };
}
